import { MDXLayoutRenderer } from '../../components/MDXComponents';
import {
  formatSlug,
  // getAllFilesFrontMatter,
  getFileBySlug,
  getFiles,
} from '../../lib/mdx';

const DEFAULT_LAYOUT = 'SimpleLayout';

export async function getStaticPaths() {
  const posts = getFiles('policies');

  return {
    paths: posts.map((p) => ({
      params: {
        slug: formatSlug(p).split('/'),
      },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const postDetails = await getFileBySlug('policies', params.slug.join('/'));
  return { props: { postDetails } };
}

export default function Policy({ postDetails }) {
  const { mdxSource, frontMatter } = postDetails;

  return (
    <MDXLayoutRenderer
      layout={frontMatter.layout || DEFAULT_LAYOUT}
      mdxSource={mdxSource}
      frontMatter={frontMatter}
    />
  );
}
